/* tslint:disable: no-switch-case-fall-through */
import { ActionWithPayload } from '../../app.interfaces';

import { helpers } from '../../helpers';
import { AssessmentActions } from './assessment.actions';
import { AssessmentState } from './assessment.interfaces';

export const assessmentInitialState: AssessmentState = {
  ricette: {},
  loadedRicette: {},
  userRequestedRicette: {},
  questionsMap: {},
  progress: {
    started: false,
    terminated: false,
    sections: {},
    questions: {}
  },
  freezeCounter: 0,
  locked: false,
  loading: false,
  loaded: false,
  mrCanStart: false,
  error: null,
  resetCounterTrigger: 0,
  syncSuccess: null,
  setAnswerSuccess: null,
  newSectionLoading: false,
  newSectionError: false,
  syncStatus: '',
};

export function assessmentReducer(state = assessmentInitialState,
  {type, payload}: ActionWithPayload): AssessmentState {
  let nextState: AssessmentState;

  switch (type) {

    case AssessmentActions.SET_METADATA: {
      nextState = helpers.immutAssign({}, state, {
        metadata: payload,
        loading: true
      });
      return nextState;
    }

    case AssessmentActions.INCREMENT_FREEZE_COUNT: {
      nextState = helpers.immutAssign({}, state, {
        freezeCounter: state.freezeCounter + 1
      });
      return nextState;
    }

    case AssessmentActions.FORCE_VIEW_TIME_SYNC: {
      nextState = helpers.immutAssign({}, state, {
        syncSuccess: false
      });
      return nextState;
    }

    case AssessmentActions.SET_SECTION_VIEW_TIME_SUCCESS: {
      nextState = helpers.immutAssign({}, state, {
        syncSuccess: true
      });
      return nextState;
    }

    case AssessmentActions.SET_ANSWER_SUCCESS: {
      nextState = helpers.immutAssign({}, state, {
        setAnswerSuccess: true
      });
      return nextState;
    }

    case AssessmentActions.LOCK_TEST: {
      nextState = helpers.immutAssign({}, state, {
        locked: true
      });
      return nextState;
    }

    case AssessmentActions.START_TEST: {
      nextState = helpers.immutAssign({}, state, {
        progress: {
          started: true
        }
      });
      return nextState;
    }

    case AssessmentActions.REQUEST_NEW_SECTION:
    case AssessmentActions.REQUEST_TERMINATE_TEST: {
      nextState = helpers.immutAssign({}, state, {
        syncSuccess: true,
        setAnswerSuccess: true,
      });
      return nextState;
    }

    case AssessmentActions.TERMINATE_TEST_SUCCESS: {
      nextState = helpers.immutAssign({}, state, {
        progress: {
          terminated: true
        },
        results: payload.score
      });
      return nextState;
    }

    case AssessmentActions.SET_PROGRESS: {
      nextState = helpers.immutAssign({}, state, {
        setAnswerSuccess: true,
        progress: payload
      });
      return nextState;
    }

    case AssessmentActions.SET_RESULTS: {
      nextState = helpers.immutAssign({}, state, {
        results: payload
      });
      return nextState;
    }

    case AssessmentActions.SET_ANSWER: {
      nextState = helpers.immutAssign({}, state, {
        setAnswerSuccess: payload,
        progress: {
          questions: {
            [payload.questionId]: {
              answerId: payload.answerId
            }
          }
        }
      });
      return nextState;
    }

    case AssessmentActions.SET_QUEUE: {
      nextState = helpers.immutAssign({}, state, {
        '>queue': payload
      });
      return nextState;
    }

    case AssessmentActions.REQUEST_RICETTE_SUCCESS: {
      nextState = helpers.immutAssign({}, state, {
        loading: false,
        loaded: true,
        '<queue': null
      });
      return nextState;
    }

    case AssessmentActions.REQUEST_FIRST_AVALIABLE_RICETTA_SUCCESS: {
      nextState = helpers.immutAssign({}, state, {
        mrCanStart: true
      });
      return nextState;
    }

    case AssessmentActions.REQUEST_RICETTE_FAIL: {
      nextState = helpers.immutAssign({}, state, {
        loading: false,
        loaded: false,
        error: payload
      });
      return nextState;
    }

    case AssessmentActions.TERMINATE_TEST_FAIL: {
      nextState = helpers.immutAssign({}, state, {
        error: payload
      });
      return nextState;
    }

    case AssessmentActions.SET_RICETTA: {
      nextState = helpers.immutAssign({}, state, {
        ricette: {
          [payload.ricettaId]: payload
        }
      });

      return nextState;
    }

    case AssessmentActions.UPDATE_RICETTE: {
      nextState = helpers.immutAssign({}, state, {
        'ricette': payload.ricette,
        progress: {
          currentQuestionId: payload.currentQuestionId
        }
      });
      return nextState;
    }

    case AssessmentActions.SET_QUESTIONS_MAP: {
      nextState = helpers.immutAssign({}, state, {
        questionsMap: payload
      });
      return nextState;
    }

    case AssessmentActions.SET_CURRENT_SECTION_ID: {
      nextState = helpers.immutAssign({}, state, {
        progress: {
          currentSectionId: payload
        }
      });
      return nextState;
    }

    case AssessmentActions.SET_CURRENT_QUESTION_ID: {
      nextState = helpers.immutAssign({}, state, {
        progress: {
          currentQuestionId: payload
        }
      });
      return nextState;
    }

    case AssessmentActions.NEW_IMAGE_RECEIVED: {
      let increment = payload.incTime || 120
        , questionId = payload.questionId
        , ricettaId
        , viewTime = 0
        , override = {}
        , resetCounterTrigger = state.resetCounterTrigger
        , originalSectionViewTime = payload.originalSectionViewTime
      ;
      if (typeof questionId !== 'undefined' && typeof state.questionsMap[questionId] !== 'undefined') {
        override['resetCounterTrigger'] = (resetCounterTrigger + 1) % 2;
        override['progress'] = {};
        ricettaId = state.questionsMap[questionId].ricetta;
        if ( typeof state.progress.sections[ricettaId] !== 'undefined') {
          viewTime = parseInt(state.progress.sections[ricettaId].viewTime);
          if (typeof originalSectionViewTime !== 'undefined') {
            viewTime = originalSectionViewTime;
          }
          viewTime = parseInt(state.progress.sections[ricettaId].viewTime) - increment;
          override['progress']['sections'] = {};
          override['progress']['sections'][ricettaId] = {
            viewTime: 0            
          }
        }
        viewTime = viewTime < 0 ? 0 : viewTime;
        override['progress']['questions'] = {};
        override['progress']['questions'][questionId] = {
          viewTime: 0
        }
      }
      nextState = helpers.immutAssign({}, state, override);
      return nextState;
    }

    case AssessmentActions.SET_QUESTION_REFRESH_ENABLED: {
      let questionId = payload.questionId, 
			override = {};

      if (typeof questionId !== 'undefined' && typeof state.questionsMap[questionId] !== 'undefined') {
        override['questionsMap'] = {};
		override['questionsMap'][questionId]= {}
		override['questionsMap'][questionId].refresh_enabled = payload.refresh_enabled;
      }
      nextState = helpers.immutAssign({}, state, override);
      return nextState;
    }

    case AssessmentActions.SET_RICETTA_LOADED: {
      nextState = helpers.immutAssign({}, state, {
        loadedRicette: {
          [payload.id_ricetta]: payload.loaded
        }
      });
      return nextState;
    }

    case AssessmentActions.SET_RICETTA_USER_REQUESTED: {
      nextState = helpers.immutAssign({}, state, {
        userRequestedRicette: {
          [payload.id_ricetta]: payload.requested
        }
      });
      return nextState;
    }

    case AssessmentActions.SET_NEW_SECTION_LOADING: {
      nextState = helpers.immutAssign({}, state, {
        newSectionLoading: payload 
      });
      return nextState;
    }

    case AssessmentActions.SET_NEW_SECTION_ERROR: {
      nextState = helpers.immutAssign({}, state, {
        newSectionError: payload 
      });
      return nextState;
    }

    case AssessmentActions.SET_SYNC_STATUS: {
      nextState = helpers.immutAssign({}, state, {
        syncStatus: payload 
      });
      return nextState;
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/logics/assessment/assessment.reducer.ts